import React, { useState, useEffect } from 'react';
import { apiClient } from '../../components/api/ApiClient';

function CompanyEditModal({ isVisible, onClose, initialData, onSave }) {
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        companyId: '',
        personType: 2,
        name: '',
        enName: '',
        personName: '',
        enPersonName: '',
        enPersonLastName: '',
        personLastName: '',
        economicCode: '',
        nationalCode: '',
        registrationNum: '',
        phoneNum: '',
        mobileNum: '',
        province: '',
        city: '',
        street: '',
        pelak: '',
        postalCode: ''
    });

    const personTypes = [
        { value: 1, label: 'حقیقی' },
        { value: 2, label: 'حقوقی' },
        { value: 3, label: 'مشارکت مدنی' },
        { value: 4, label: 'اتباع غیر ایرانی' }
    ];

    useEffect(() => {
        if (!isVisible) return;
        
        async function fetchProvinces() {
            try {
                const provincesRes = await apiClient('/account/api/provinces');
                setProvinces(provincesRes || []);
            } catch (err) {
                console.error("Error fetching provinces:", err);
            }
        }
        fetchProvinces();
    }, [isVisible]);

    useEffect(() => {
        if (!isVisible || !formData.province) {
            setCities([]);
            return;
        }

        async function fetchCities() {
            try {
                const citiesRes = await apiClient(`/account/api/cities/?province=${formData.province}`);
                setCities(citiesRes || []);
            } catch (err) {
                console.error("Error fetching cities:", err);
            }
        }
        fetchCities();
    }, [formData.province, isVisible]);

    useEffect(() => {
        if (initialData) {
            setFormData({
                companyId: initialData.id || '',
                personType: initialData.personType || 2,
                name: initialData.name || '',
                enName: initialData.enName || '',
                personName: initialData.personName || '',
                enPersonName: initialData.enPersonName || '',
                enPersonLastName: initialData.enPersonLastName || '',
                personLastName: initialData.personLastName || '',
                economicCode: initialData.economicCode || '',
                nationalCode: initialData.nationalCode || '',
                registrationNum: initialData.registrationNum || '',
                phoneNum: initialData.phoneNum || '',
                mobileNum: initialData.mobileNum || '',
                province: initialData.province || '',
                city: initialData.city || '',
                street: initialData.street || '',
                pelak: initialData.pelak || '',
                postalCode: initialData.postalCode || ''
            });
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleProvinceChange = (e) => {
        setFormData(prev => ({ ...prev, province: e.target.value, city: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const payload = {
            companyId: formData.companyId,
            personType: parseInt(formData.personType),
            name: formData.name,
            enName: formData.enName || null,
            personName: formData.personName || null,
            enPersonName: formData.enPersonName || null,
            enPersonLastName: formData.enPersonLastName || null,
            personLastName: formData.personLastName || null,
            economicCode: formData.economicCode,
            nationalCode: formData.nationalCode,
            registrationNum: formData.registrationNum,
            phoneNum: formData.phoneNum,
            mobileNum: formData.mobileNum,
            province: parseInt(formData.province) || null,
            city: parseInt(formData.city) || null,
            street: formData.street,
            pelak: formData.pelak,
            postalCode: formData.postalCode
        };

        try {
            await apiClient('/companies/api/', {
                method: initialData ? 'PUT' : 'POST',
                data: payload
            });
            onSave();
            onClose();
        } catch (err) {
            console.error("Error saving company:", err);
            alert("خطا در ذخیره اطلاعات: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    if (!isVisible) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">مشخصات بنگاه اقتصادی جدید</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <h6 className="fw-bold mb-3">مشخصات اصلی</h6>
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label className="form-label">نوع شخصیت تجاری <span className="text-danger">*</span></label>
                                    <select className="form-select" name="personType" value={formData.personType} onChange={handleChange} required>
                                        {personTypes.map(pt => (
                                            <option key={pt.value} value={pt.value}>{pt.label}</option>
                                        ))}
                                    </select>
                                </div>
                                {parseInt(formData.personType) === 1 ? (
                                    <>
                                        <div className="col-md-4">
                                            <label className="form-label">نام بنگاه اقتصادی <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">نام <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="personName" value={formData.personName} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">نام خانوادگی <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="personLastName" value={formData.personLastName} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">نام به انگلیسی</label>
                                            <input type="text" className="form-control" name="enPersonName" value={formData.enPersonName} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">نام خانوادگی به انگلیسی</label>
                                            <input type="text" className="form-control" name="enPersonLastName" value={formData.enPersonLastName} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">کد ملی <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="nationalCode" value={formData.nationalCode} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">کد اقتصادی <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="economicCode" value={formData.economicCode} onChange={handleChange} required />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-md-4">
                                            <label className="form-label">نام بنگاه تجاری <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">نام کامل به انگلیسی <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="enName" value={formData.enName} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">کد اقتصادی <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="economicCode" value={formData.economicCode} onChange={handleChange} required />
                                        </div>
                                    </>
                                )}
                            </div>

                            <h6 className="fw-bold mb-3 mt-4">مشخصات ملی</h6>
                            <div className="row g-3">
                                {parseInt(formData.personType) === 1 ? (
                                    <>
                                        <div className="col-md-4">
                                            <label className="form-label">تلفن همراه <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="mobileNum" value={formData.mobileNum} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">تلفن ثابت <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="phoneNum" value={formData.phoneNum} onChange={handleChange} required />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-md-4">
                                            <label className="form-label">شناسه ملی <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="nationalCode" value={formData.nationalCode} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">شماره ثبت <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="registrationNum" value={formData.registrationNum} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">تلفن همراه صاحب بنگاه <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="mobileNum" value={formData.mobileNum} onChange={handleChange} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">تلفن ثابت <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name="phoneNum" value={formData.phoneNum} onChange={handleChange} required />
                                        </div>
                                    </>
                                )}
                            </div>

                            <h6 className="fw-bold mb-3 mt-4">آدرس</h6>
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label className="form-label">استان <span className="text-danger">*</span></label>
                                    <select className="form-select" name="province" value={formData.province} onChange={handleProvinceChange} required>
                                        <option value="">انتخاب کنید...</option>
                                        {provinces.map(p => (
                                            <option key={p.code} value={p.code}>{p.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">شهر <span className="text-danger">*</span></label>
                                    <select className="form-select" name="city" value={formData.city} onChange={handleChange} required disabled={!formData.province}>
                                        <option value="">انتخاب کنید...</option>
                                        {cities.map(c => (
                                            <option key={c.code} value={c.code}>{c.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">خیابان و کوچه <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" name="street" value={formData.street} onChange={handleChange} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">پلاک و مشخصات اضافه <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" name="pelak" value={formData.pelak} onChange={handleChange} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">کد پستی <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" name="postalCode" value={formData.postalCode} onChange={handleChange} />
                                </div>
                            </div>

                            <div className="modal-footer mt-4">
                                <button type="button" className="btn btn-danger" onClick={onClose}>لغو</button>
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? 'در حال ذخیره...' : 'ذخیره تغییرات'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompanyEditModal;
